import { ShieldLockIcon } from './ShieldLockIcon';

/**
 * author: GreenTurtwig
 * id C2E5EBC9-F1AD-4D93-BA3F-C81E18411E09
 * name shield-lock
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-lock.svg
 * tags
 * - Lock 
 * - Home Automation 
 */
export const AlarmArmAwayIcon = ShieldLockIcon;
export default AlarmArmAwayIcon